import React, { createContext } from 'react';
import { IPortfolioPerformanceAccounts } from '../portfolio-performance.types';
import { useAccountPerformance } from './use-account-performance';
import { RiskContextValue } from './risk.types';

export const RiskContext = createContext<RiskContextValue>({} as any);

export const RiskProvider: React.FC<{
  account: IPortfolioPerformanceAccounts;
  children: React.ReactNode;
}> = ({ account, children }) => {
  const riskAccountPerformance = useAccountPerformance(account);

  return (
    <RiskContext.Provider
      value={{
        ...riskAccountPerformance,
        account,
      }}
    >
      {children}
    </RiskContext.Provider>
  );
};
